<template>
    <div class="filter-selector">
        <span class="selector-label">Filter by {{ verbose.toLowerCase() }}</span>
        <el-select
            class="selector"
            v-model="selectedValue"
            :placeholder="computedVerbose"
            :filterable="list.length > lengthForAutoComplete"
            multiple
            style="width: 100%"
            @change="triggerEmit"
        >
            <el-option
                v-for="item in optionList"
                :key="item.value"
                :label="formatFunction(item.value)"
                :value="item.value"
            ></el-option>

        </el-select>
    </div>
</template>

<script>
import schwartz from 'schwartz';
import { mapGetters } from 'vuex';
export default {

    components: {

    },

    props: {
        verbose: {
            type: String,
            required: true,
        },

        list: {
            type: Array,
            required: true,
        },

        formatFunction: {
            type: Function,
            default (item){
                if(typeof item === 'boolean'){
                    return item.toString();
                }
                return item;
            },
        },

        filtersValues: {
            type: Array,
            required: true,
        },

        defaultValue: {
            type: [Array, String],
            default: '',
        },

    },

    data: function(){
        return {
            selectedValue: [],
            remoteList: [],
            lengthForAutoComplete: 15
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getVerbose'
        ]),
        optionList (){
            let list = [];
            list = this.list.map(item => {
                if(item === null) return false;
                return { value: item.toString(), label: this.formatFunction(item.toString()) };
            }).filter(Boolean);
            return schwartz(list, (item => item.label));
        },

        computedVerbose (){
            if(this.list.length > this.lengthForAutoComplete){
                return `${this.getVerbose('new_ns_paginate_filters_input_placeholder')} ${this.verbose.toLowerCase()}`;
            }
            return `${this.getVerbose('new_ns_paginate_filters_select_placeholder')} ${this.verbose.toLowerCase()}`;
        },
    },

    created (){
        if (this.defaultValue instanceof Array){
            this.$set(this, 'selectedValue', this.defaultValue);
        }else if(this.defaultValue !== ''){
            this.selectedValue.push(this.defaultValue);
        }
    },

    methods: {
        displayCheckbox(value) {
            return this.filtersValues.includes(value);
        },
        triggerEmit (val){
            this.$emit('valueUpdated', val);
        },

        resetCalled (){
            this.$set(this, 'selectedValue', []);
        },
        remoteMethod (query){
            if(query !== ''){
                this.remoteList = this.list.filter((item) => {
                    return this.formatFunction(item).toLowerCase().includes(query.toLowerCase());
                });
            }else{
                this.$set(this, 'remoteList', []);
            }
        },
    },
};
</script>

<style lang="scss">
.filter-selector {
    .selector-label {
        margin-bottom: 8px;
        display: block;
    }
    .selector {
        input {
            border: none;
            box-shadow: 0px 1px 4px rgba(207, 206, 207, 0.25);
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/nsPaginate2/filter-select.vue